module.exports = __webpack_public_path__ + "static/img/1570.b238861.png";